import styled from 'styled-components';

import type { Props as LoadingButtonProps } from '#src/atoms/buttons/LoadingButton/index.tsx';
import { LoadingButton } from '#src/atoms/buttons/LoadingButton/index.tsx';
import { useIsTabletAndAbove } from '#src/hooks/device/useIsTabletAndAbove.ts';

const StyledButton = styled(LoadingButton)`
  &.medium,
  &.large {
    min-width: 240px;
  }
`;

export const OnboardingButton = ({
  loading,
  ...otherProps
}: Omit<LoadingButtonProps, 'loading'> & {
  loading?: boolean;
}) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <StyledButton
      {...otherProps}
      fullWidth={!isTabletAndAbove}
      loading={!!loading}
    />
  );
};
